import { useAppSelector } from "../useAppSelector";
import {
  selectToken,
  selectUser,
  selectIsAuthenticated,
  selectAuthError,
  selectAuthLoading,
} from "@/features/auth/authSelectors";

export const useAuth = () => {
  const token = useAppSelector(selectToken);
  const user = useAppSelector(selectUser);
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const error = useAppSelector(selectAuthError);
  const loading = useAppSelector(selectAuthLoading);

  return {
    token,
    user,
    isAuthenticated,
    error,
    loading,
  };
};
